<template>
  <div class="withdraw">
    <my-header title="Withdraw"></my-header>
    <div class="ui form">
      <div class="field">
        <div class="ui input">
          <input type="text" v-model="address" placeholder="blockchain Address" maxlength="200">
        </div>
      </div>
      <div class="field">
        <div class="flex">
          <div class="ui input">
            <input type="text" v-model="amount" maxlength="50" placeholder="Withdrawal Amount">
          </div>
        </div>
      </div>
      <div class="field">
        <div class="expense">
          <div class="col">Miners expenses</div>
          <div class="col">0.0005 BTC</div>
        </div>
      </div>
      <div class="field footer-button">
        <div class="ui button instagram" :class="{disabled:!isValidForm}" @click="transfer">Transfer immediately</div>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '@/components/MyHeader.vue';
import {createWithdraw} from "../http/api";

export default {
  components: { MyHeader },
  name: "WithdrawView",
  data() {
    return {
      address:"",
      amount:"",
      currency:""
    };
  },
  created() {
    this.currency = this.$route.query.currency;
  },
  computed: {
    isValidForm() {
      return this.address && this.amount;
    },
  },
  methods: {
    async transfer(){
      const pattern = /^[0-9]+(\.[0-9]+)?$/;
      const validate = pattern.test(this.amount);
      if(!validate){
        this.$toast.show("Amount format error","40%");
        return;
      }
      const data = {
        currency:this.currency,
        address:this.address,
        amount:this.amount
      }
      const res = await createWithdraw(data)
      if(res && res.message){
        this.$toast.show(res.message,"40%");
        this.$router.replace('home');
      }
    }
  }
};
</script>

<style lang="less" scoped>
.withdraw{
  .form{
    width: 80%;
    margin: 50px auto;
  }
  .expense{
    .col{
      display: inline-block;
      width: 45%;
      font-size: 16px;
    }
  }
  .footer-button{
    text-align: center;
    margin-top: 30px;
  }
}
</style>